var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmbulance2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 19C9 20.1046 8.10457 21 7 21C5.89543 21 5 20.1046 5 19C5 17.8954 5.89543 17 7 17C8.10457 17 9 17.8954 9 19Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19C19 20.1046 18.1046 21 17 21C15.8954 21 15 20.1046 15 19C15 17.8954 15.8954 17 17 17C18.1046 17 19 17.8954 19 19Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 4H4C2.89543 4 2 4.89543 2 6V17C2 17.9321 2.63766 18.7153 3.50056 18.9371C3.53409 17.0331 5.088 15.5 7 15.5C8.933 15.5 10.5 17.067 10.5 19H13.5C13.5 17.067 15.067 15.5 17 15.5C18.912 15.5 20.4659 17.0331 20.4994 18.9371C21.3623 18.7153 22 17.9321 22 17V11.75H16C14.4812 11.75 13.25 10.5188 13.25 9V4ZM8.05 6C8.32614 6 8.55 6.22386 8.55 6.5V8.45H10.5C10.7761 8.45 11 8.67386 11 8.95V10.05C11 10.3261 10.7761 10.55 10.5 10.55H8.55V12.5C8.55 12.7761 8.32614 13 8.05 13H6.95C6.67386 13 6.45 12.7761 6.45 12.5V10.55H4.5C4.22386 10.55 4 10.3261 4 10.05V8.95C4 8.67386 4.22386 8.45 4.5 8.45H6.45V6.5C6.45 6.22386 6.67386 6 6.95 6H8.05Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5714 10.25L18.5758 5.00772C18.2198 4.38457 17.5571 4 16.8394 4H14.75V9C14.75 9.69036 15.3096 10.25 16 10.25H21.5714Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulance2);
export default __webpack_public_path__ + "static/media/ambulance-2.3340aeb141078bf8230b60ec9a52e249.svg";
export { ForwardRef as ReactComponent };